// import components
import { styled, Link } from '@mui/material';

export const StyledLink = styled(Link)(() => ({
  textDecoration: 'none'
}));
